import React from 'react'
import ReactDOM from 'react-dom/client'
import { getSiteMode } from './utils/siteConfig.js'
import './index.css'

// windier.app (marketing) vs forecast.windier.app (the signed-in app) —
// one deployment serves both, branching here based on hostname (see
// src/utils/siteConfig.js). Dynamically imported so each site only ever
// downloads its own bundle — marketing visitors never pull in Firebase
// or the rest of the forecast app, and vice versa.
const mode = getSiteMode()
const loadRootApp = mode === 'forecast'
  ? import('./App.jsx')
  : import('./MarketingApp.jsx')

loadRootApp.then(({ default: RootApp }) => {
  const rootEl = document.getElementById('root')

  if (mode === 'forecast') {
    // The forecast app isn't prerendered (auth-gated, nothing for a
    // crawler to see) — render it fresh as before. #root starts hidden on
    // this host (see index.html's inline guard script) to stop the
    // marketing HTML baked into this same static file from flashing before
    // this runs — now that the real app is actually mounted, reveal it.
    rootEl.removeAttribute('data-prerendered')
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <RootApp />
      </React.StrictMode>,
    )
    return
  }

  // Marketing routes ship real prerendered HTML (see scripts/prerender.mjs)
  // — hydrate into it rather than wiping and re-rendering from scratch, so
  // the content that was already visible on first paint stays put instead
  // of flashing empty and re-appearing.
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <RootApp />
    </React.StrictMode>,
  )
})
